<template>
  <div class="num-list">
    <div v-for="(item, i) in localValue" :key="i" class="num" :style="{ width: item === '1' ? '12px' : '' }">
      <div
        class="num-box"
        :style="{ transform: `translate(0, -${item * 10}%)` }"
      >
        <img v-for="(item, i) in '0123456789'" :key="i" :src="nums[item]" />
      </div>
    </div>
  </div>
</template>

<script>
import num0 from "@/assets/0.png"
import num1 from "@/assets/1.png"
import num2 from "@/assets/2.png"
import num3 from "@/assets/3.png"
import num4 from "@/assets/4.png"
import num5 from "@/assets/5.png"
import num6 from "@/assets/6.png"
import num7 from "@/assets/7.png"
import num8 from "@/assets/8.png"
import num9 from "@/assets/9.png"

export default {
  props: {
    value: [String],
  },
  data() {
    return {
      localValue: "",
      nums: {
        0: num0,
        1: num1,
        2: num2,
        3: num3,
        4: num4,
        5: num5,
        6: num6,
        7: num7,
        8: num8,
        9: num9,
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function(newVal, oldVal) {
        if (!oldVal) {
          this.localValue = new Array(newVal.length).fill(0).join("")
        }

        clearTimeout(this.timer)

        this.timer = setTimeout(() => {
          this.localValue = newVal
        }, 300)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.num-list {
  display: inline-block;
  .num {
    display: inline-block;
    width: 21px;
    height: 20px;
    overflow: hidden;
    .num-box {
      transition: all 0.5s;
      text-align: center;
      img {
        height: 20px;
        display: block;
        margin: 0 auto;
      }
    }

    &:hover {
      .num-box {
        transform: translate(0, -90%);
      }
    }
  }
}
</style>
